import api from "../libs/api";

export default {
	getQA: (page = 1, perPage = 10, sortBy = "", sortOrder = "") => {
		return new Promise((resolve, reject) => {
			const queryParams = new URLSearchParams({
				page,
				perPage,
				sortBy,
				sortOrder,
			}).toString();

			api()
				.get(`/list-quality-assurance?${queryParams}`)
				.then(({ status, data }) => {
					if (status === 200) {
						resolve({
							data: data.data,
							meta: data.meta,
							links: data.links,
						});
					}
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	postQA: (data) => {
		return new Promise((resolve, reject) => {
			api()
				.post("/quality-assurance", data, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(({ status, data }) => {
					if (status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	sendQaRequest: (selectedForm, currentKey, users) => {
		const formData = new FormData();
		formData.append("form_id", selectedForm);
		formData.append("key", currentKey);
		users.forEach((user, index) => {
			formData.append(`qa_user_ids[${index}]`, user);
		});

		return new Promise((resolve, reject) => {
			api()
				.post(`/qa-assign`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getifQaAssigned: (detail) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/get-qa-assigned/add?detail=${detail}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getQaRequestByParam: (selectedForm, currentKey, users) => {
		const formData = new FormData();
		formData.append("form_id", selectedForm);
		formData.append("key", currentKey);
		users.forEach((user, index) => {
			formData.append(`users[${index}]`, user);
		});

		return new Promise((resolve, reject) => {
			api()
				.get(`/send-qa-request`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateUat: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.post(`/quality-assurance/${id}`, data, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
					params: {
						_method: "PUT",
					},
				})
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateQAStatus: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.post(`/status-quality-assurance/${id}`, data, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
					params: {
						_method: "PUT",
					},
				})
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getQaDetails: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/quality-assurance/${id}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	deleteQaAttachment: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.delete(`/qa-attachments/${id}`, {
					headers: {
						"Content-Type": "application/json",
					},
				})
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},
};
